"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
class MenuGroup extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            this.setState((prevState) => ({
                groupOpened: !prevState.groupOpened,
            }));
        };
        this.state = {
            groupOpened: false,
        };
    }
    render() {
        const { item } = this.props;
        const items = item.sections;
        let i = 0;
        if (!item) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "menu-group" },
            react_1.default.createElement("div", { className: "menu-group-header", onClick: this.handleClick },
                react_1.default.createElement("div", { className: "text-gap" },
                    react_1.default.createElement(next12_components_text_info_n_1.default, { text: item.text, fontType: "font-regular", size: "caption01", color: "grey5", display: "block" })),
                react_1.default.createElement("div", { className: "icon-gap" },
                    !this.state.groupOpened && (react_1.default.createElement(next12_components_icon_n_1.default, { id: "cheuron-down", kind: "M", size: 12, color: "grey5" })),
                    this.state.groupOpened && (react_1.default.createElement(next12_components_icon_n_1.default, { id: "cheuron-up", kind: "M", size: 12, color: "grey5" })))),
            this.state.groupOpened && (react_1.default.createElement("div", { className: "sections" }, items.map((subitem) => {
                const link = subitem.link ? item.link : "#";
                const { text } = subitem;
                return (react_1.default.createElement("div", { key: `item-${i++}`, className: "menu-item" },
                    react_1.default.createElement(next12_components_custom_link_1.default, { href: link, title: "", ariaLabel: "", taggingInfo: {
                            componentName: "header",
                            componentContent: "menu",
                            componentVariation: "all",
                            componentPerso: "",
                            componentProduct: "",
                        } },
                        react_1.default.createElement(next12_components_text_info_n_1.default, { text: text, fontType: "font-regular", size: "caption01", color: "grey5", display: "block" }))));
            })))));
    }
}
exports.default = MenuGroup;
//# sourceMappingURL=index.js.map